import axiosInstance from '../functions/axiosInstance';
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const getVersionDifference = async (resourceId, newVersionNumber, oldVersionNumber,
    newHistoryId, oldHistoryId, justTheDifferences, apiToken = null) => {
    console.log("CALLING SERVER with getversiondifference")
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            "functionid": "getversiondifference",
            "apiToken": apiToken,
            'resourceid': resourceId,
            'versionnew': newVersionNumber,
            'versionold': oldVersionNumber,
            'versionnewid': newHistoryId,
            'versionoldid': oldHistoryId,
            'onlydifferences': justTheDifferences ?? true
        },
    }).then((resp) => {
        if (resp?.data) {
            //resp.data is { 'success': true, 'jsonDifferences': [] }
            if (resp.data.success && resp.data.jsonDifferences) {
                return resp.data.jsonDifferences;
            } else {
                console.log("FAILED RESPONSE from getversiondifference call")
                return [];
            }
        }
        console.log("NO RESPONSE from getversiondifference call");
        return [];
    }).catch((error) => { console.log(error); return []; });
}

const getHistoryVersionOfResource = async (resourceId, selectedVersion, apiToken = null) => {
    console.log("CALLING SERVER with gethistoryversionofresource")
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'gethistoryversionofresource',
            'resourceid': resourceId,
            'version': selectedVersion,
            "apiToken": apiToken
        }
    }).then((resp) => {
        if (resp?.data) {
            //console.log(resp.data)
            //resp.data is { 'success': true, 'fhirjson': "", 'resourcetype': "", 'status': "", "found": true }
            //resp.data is {success: true,
            //  fhirjson:'{  "resourceType": "Composition",  "meta": {   …"display": "Brian S. Alper, MD, MSPH"   }  ]}',
            //  resourcetype: 'Composition', status: 'active', found: true}
            if (resp.data.warning) {
                alert(resp.data.warning);
            }
            if (resp.data.success) {
                return resp.data;
            } else {
                console.log("FAILED RESPONSE from gethistoryversionofresource call")
                return {};
            }
        }
        console.log("NO RESPONSE from gethistoryversionofresource call");
        return {};
    }).catch((error) => { console.log(error); return {}; });
}

const loadResourceVersionList = async (resourceId, apiToken = null) => {
    console.log("CALLING SERVER with loadResourceVersionList")
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'getresourceversionlist',
            'resourceid': resourceId,
            "apiToken": apiToken
        }
    }).then((resp) => {
        if (resp?.data) {
            if (resp.data.success && resp.data.resourceversionlist) {
                //resp.data is { 'success': true, 'resourceversionlist': [] }
                return resp.data.resourceversionlist;
            } else {
                console.log("FAILED RESPONSE from loadResourceVersionList call")
                return [];
            }
        }
        console.log("NO RESPONSE from loadResourceVersionList call");
        return [];
    }).catch((error) => { console.log(error); return []; });
}

export { getVersionDifference, getHistoryVersionOfResource, loadResourceVersionList };